/**
 * Gets the active panel of the form
 */
export default function getActivePanel(form) {
  return form.querySelector('.lead-constructor__panel.active');
}



// WEBPACK FOOTER //
// ./client/app/scripts/leadform/models/form/get_active_panel.js